import { isUndefined } from 'lodash'

export default class AttributeListingFiltersModel {
  uriWithoutOffset = ''
  filterQueryStringVar = ''
  activeFilters = []
  isTopLevelCategory = false
  currentPageNumber = null
  urlLang = ''
  activeVariationsFiltersString = ''

  constructor (uriWithoutOffset, filterQueryStringVar, activeFilters, isTopLevelCategory, currentPageNumber, urlLang, activeVariationsFiltersString) {
    this.uriWithoutOffset = uriWithoutOffset
    this.filterQueryStringVar = filterQueryStringVar
    this.activeFilters = activeFilters
    this.isTopLevelCategory = isTopLevelCategory
    this.currentPageNumber = currentPageNumber
    this.urlLang = urlLang
    this.activeVariationsFiltersString = activeVariationsFiltersString
  }

  static isTextRangeGroup (group) {
    if (isUndefined(group.attributes.chunks) && group.attributes.length > 0) {
      return false
    }
    return (group.attributeDisplayType === 'text-range-per-count' || group.attributeDisplayType === 'text-range-per-value') && group.attributes.chunks.length > 0
  }

  static inactivateTextRageFilter (entry, activeFilters) {
    const chunkValueIds = entry.chunkValueIds

    activeFilters = activeFilters.filter(e => {
      return !chunkValueIds.includes(e)
    })

    return activeFilters
  }

  static inactivateBaseFilter (entry, activeFilters) {
    const attributeId = entry.attributeId

    activeFilters = activeFilters.filter(e => {
      const activeFilterId = e.replace(/\/\d+$/, '')
      return Number(activeFilterId) !== Number(attributeId)
    })

    return activeFilters
  }

  removeQueryString (
    group,
    entry,
    activeFilters
  ) {
    let str = this.activeVariationsFiltersString

    if (this.activeFilters === null) {
      return ''
    }

    activeFilters = AttributeListingFiltersModel.inactivateBaseFilter(entry, this.activeFilters)

    if (activeFilters.length > 0) {
      if (this.activeVariationsFiltersString !== '') {
        str += '&'
      }
      str += `${this.filterQueryStringVar}[]=${activeFilters.join(`&${this.filterQueryStringVar}[]=`)}`
    }

    return (str !== '') ? `?${str}` : '/' + this.urlLang + this.uriWithoutOffset
  }

  addQueryString (
    group,
    entry,
    activeFilters
  ) {
    let str = this.activeVariationsFiltersString

    if (activeFilters === null) {
      return ''
    }

    if (activeFilters.length > 0) {
      if (this.activeVariationsFiltersString !== '') {
        str += '&'
      }
      str += `${this.filterQueryStringVar}[]=${activeFilters.join(`&${this.filterQueryStringVar}[]=`)}`
    }

    return `?${str}`
  }

  createLinkQueryStringForBaseGroup (group, entry, isFilterUsed) {
    let finalString = ''
    const activeFilters = [...this.activeFilters]

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (this.activeFilters.length === 1) {
        return this.queryStringForLastActiveFilter()
      }
    } else {
      finalString = this.addQueryString(group, entry, activeFilters) + '&' + this.filterQueryStringVar + '[]=' + entry.attributeId

      if (this.activeFilters === null) {
        finalString = this.addQueryString(group, entry, activeFilters) + '?' + this.filterQueryStringVar + '[]=' + entry.attributeId
      }
    }

    if (this.isTopLevelCategory) {
      return finalString + '/1'
    }

    return '/' + this.urlLang + this.uriWithoutOffset + finalString
  }

  createLinkQueryStringFinal (group, entry, isFilterUsed) {
    return this.createLinkQueryStringForBaseGroup(group, entry, isFilterUsed)
  }

  queryStringForLastActiveFilter () {
    const firstEntryString = '/' + this.urlLang + this.uriWithoutOffset
    if (this.isTopLevelCategory) {
      if (this.activeVariationsFiltersString !== '') {
        return firstEntryString + '/1' + '?' + this.activeVariationsFiltersString
      }
      return firstEntryString + '/1'
    }

    if (this.activeVariationsFiltersString !== '') {
      return firstEntryString + '?' + this.activeVariationsFiltersString
    }

    return firstEntryString
  }
}
